(() => {
  function measure(data, width, height) {
    const clear = (x, y) => {
      const i = (y * width + x) * 4;
      return data[i + 3] < 24 || (Math.min(data[i], data[i + 1], data[i + 2]) > 238 && Math.max(data[i], data[i + 1], data[i + 2]) - Math.min(data[i], data[i + 1], data[i + 2]) < 14);
    };
    let border = 0, clean = 0;
    for (let x = 0; x < width; x += 2) for (const y of [0, 1, height - 2, height - 1]) { border++; if (clear(x, y)) clean++; }
    for (let y = 0; y < height; y += 2) for (const x of [0, 1, width - 2, width - 1]) { border++; if (clear(x, y)) clean++; }
    if (clean / border < .97) return null;
    let minX = width, minY = height, maxX = -1, maxY = -1, count = 0;
    for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
      const i = (y * width + x) * 4;
      if (data[i + 3] > 24 && Math.min(data[i], data[i + 1], data[i + 2]) < 236) {
        minX = Math.min(minX, x); minY = Math.min(minY, y); maxX = Math.max(maxX, x); maxY = Math.max(maxY, y); count++;
      }
    }
    if (count < 32 || maxX <= minX || maxY <= minY) return null;
    minX = Math.max(0, minX - 3); minY = Math.max(0, minY - 3); maxX = Math.min(width, maxX + 4); maxY = Math.min(height, maxY + 4);
    return { x: minX / width, y: minY / height, width: (maxX - minX) / width, height: (maxY - minY) / height };
  }
  function framing(box, fill = .76) {
    if (!box) return null;
    const scale = Math.min(2.2, fill / Math.max(box.width, box.height));
    const center = box.x + box.width / 2;
    return { size: scale * 100, x: 50 + (0.5 - center) * scale * 100, y: 50 + (0.5 - box.y - box.height / 2) * scale * 100 };
  }
  function fillFor(presentation) {
    return ({ glass: .60, tumbler: .48, pitcher: .73, vase: .76, floral: .76, chandelier: .80, object: .76 })[presentation] || .76;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { measure, framing, fillFor }; return; }
  const cache = new Map();
  const watched = new WeakSet();
  const canvas = document.createElement('canvas'); canvas.width = canvas.height = 160;
  const context = canvas.getContext('2d', { willReadFrequently: true });
  function apply(img) {
    // Reviewed source-matched frames are shared by every card renderer.
    if (img.dataset.auraScale === 'reviewed' || img.dataset.auraScale === 'pilot') return;
    if (img.dataset.auraPresentation === 'scene') {
      img.dataset.auraFramed = 'photograph'; return;
    }
    if (!img.naturalWidth || !context) return;
    const key = img.currentSrc || img.src;
    let box = cache.get(key);
    if (box === undefined) {
      try {
        canvas.width = canvas.height = 160;
        context.fillStyle = '#fff'; context.fillRect(0, 0, 160, 160);
        const fit = Math.min(160 / img.naturalWidth, 160 / img.naturalHeight);
        const w = img.naturalWidth * fit, h = img.naturalHeight * fit;
        context.drawImage(img, (160 - w) / 2, (160 - h) / 2, w, h);
        box = measure(context.getImageData(0, 0, 160, 160).data, 160, 160);
        cache.set(key, box);
      } catch (_) { return; }
    }
    const fill = fillFor(img.dataset.auraPresentation);
    const result = framing(box, fill);
    if (!result) {
      for (const key of ['--ae-frame-size', '--ae-frame-x', '--ae-frame-y']) img.style.removeProperty(key);
      img.dataset.auraFramed = 'photograph'; return;
    }
    img.style.setProperty('--ae-frame-size', `${result.size.toFixed(3)}%`);
    img.style.setProperty('--ae-frame-x', `${result.x.toFixed(3)}%`);
    img.style.setProperty('--ae-frame-y', `${result.y.toFixed(3)}%`);
    img.dataset.auraFramed = 'object';
  }
  const near = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const img = entry.target; near.unobserve(img);
    img.addEventListener('load', () => apply(img));
    if (img.complete) apply(img);
  }), { rootMargin: '300px' });
  function scan(root) {
    const images = [];
    if (root.matches?.('img[data-aura-frame]')) images.push(root);
    if (root.querySelectorAll) images.push(...root.querySelectorAll('img[data-aura-frame]'));
    images.forEach(img => { if (!watched.has(img)) { watched.add(img); near.observe(img); } });
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
})();
